<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  import { getFormContext, getStore } from "../../../context";

  export let id: string;
  export let value: string;
  export let name: string;
  export let type: "checkbox" | "radio" = "checkbox";
  export let required: boolean = false;

  let element: HTMLInputElement;

  const { formElement } = getStore();
  const { addCheckbox, removeCheckbox, checkCustomValidity } = getFormContext();

  onMount(() => {
    addCheckbox({ name, element });
  });

  onDestroy(() => {
    removeCheckbox({ name, element });
  });

  function handleChange() {
    if (!$formElement) {
      return;
    }

    checkCustomValidity($formElement);
  }
</script>

<label class="form-checkbox-container">
  <input
    {type}
    class="form-checkbox"
    required={type === "radio" && required ? true : undefined}
    {id}
    {name}
    {value}
    on:change={handleChange}
    bind:this={element}
  />
  <div class="form-checkbox-marker">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1"
    >
      <path
        fill-rule="evenodd"
        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
        clip-rule="evenodd"
      ></path>
    </svg>
  </div>
</label>

<style>
  .form-checkbox-container {
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .form-checkbox {
    position: relative;
    height: var(--cb-text-lg);
    width: var(--cb-text-lg);
    cursor: pointer;
    appearance: none;
    border-radius: 99999px;
    border-width: 1px;
    border-color: rgba(var(--cb-form-base-color), 1);
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
    background-color: white;
  }

  .form-checkbox:hover,
  .form-checkbox:focus,
  .form-checkbox:active {
    border-color: rgba(var(--cb-form-primary-color), 0.5);
  }

  .form-checkbox:checked {
    background-color: rgba(var(--cb-form-primary-color), 1);
    border-color: rgba(var(--cb-form-primary-color), 1);
  }

  .form-checkbox-marker {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    transition-property: opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
    opacity: 0;
    pointer-events: none;
  }

  .form-checkbox-marker svg {
    width: calc(var(--cb-form-font-size) * 0.5);
    height: calc(var(--cb-form-font-size) * 0.5);
  }

  .form-checkbox:checked ~ .form-checkbox-marker {
    opacity: 1;
  }
</style>
